import { Box, Button, styled } from '@mui/material';

export const MainMenuContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  minHeight: 'inherit',
  maxHeight: 'inherit',
  padding: theme.spacing(0, 1.8, 1.6, 1.8),

  '.MuiListItemButton-root': {
    paddingLeft: theme.spacing(1)
  },

  '.MuiIconButton-root': {
    paddingRight: theme.spacing(0)
  }
}));

export const MainMenuTopWrapper = styled(Box)`
  width: 100%;
`;

export const MainMenuBottomWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const HelpWrapper = styled(Button)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  padding-left: ${theme.spacing(1)};
  color: inherit;
  `
);

export const MainMenuUserWrapper = styled(Box)`
  display: grid;
  grid-template-columns: auto 1fr auto;
  width: 100%;
`;

export const NotificationsWrapper = styled(Box)(
  ({ theme }) => `
  display: flex;
  align-items: center;
  column-gap: ${theme.spacing(1)};
`
);

export const Divider = styled(Box)(
  ({ theme }) => `
  height: ${theme.spacing(2)};
`
);
